// 燃气控
import Log from '../view/log'
import GasManagementNav from '../view/GasManage/GasManagementNav'
import GasControllerManagement from '../view/GasManage/ControllerManagement/ControllerManagement'
import GasControllerAdd from '../view/GasManage/ControllerManagement/ControllerAdd'
import GasControllerCurrent from '../view/GasManage/ControllerManagement/ControllerCurrent'
import GasControllerModify from '../view/GasManage/ControllerManagement/ControllerModify'
import GasControllerDeviceStatusLog from '../view/GasManage/ControllerDeviceStatusLog/ControllerDeviceStatusLog'
import GasAmmeterManagement from '../view/GasManage/AmmeterManagement/AmmeterManagement'
import GasAmmeterAdd from '../view/GasManage/AmmeterManagement/AmmeterAdd'
import GasAmmeterCurrent from '../view/GasManage/AmmeterManagement/AmmeterCurrent'
import GasAmmeterModify from '../view/GasManage/AmmeterManagement/AmmeterModify'
import GasDeviceSceneConfig from '../view/GasManage/DeviceSceneConfig/DeviceSceneConfig'
import GasConfigCenter from '../view/GasManage/GasConfig/GasConfigCenter'
import GasConfigModify from '../view/GasManage/GasConfig/GasConfigModify'
import GasAccountCenter from '../view/GasManage/GasAccountConfig/GasAccountCenter'
import GasAccountModify from '../view/GasManage/GasAccountConfig/GasAccountModify'
import GasPayRecord from '../view/GasManage/GasPayRecord/GasPayRecord'
import GasRentMoney from '../view/GasManage/GasRentMoney/GasRentMoney'
import GasQuantity from '../view/GasManage/GasQuantity/GasQuantity'
import GasQuantityPublic from '../view/GasManage/GasQuantityPublic/GasQuantityPublic'
import GasOverView from '../view/GasManage/OverView/OverView'
import GassettlementRecord from '../view/GasManage/settlementRecord/settlementRecord'
import GasConfigSettle from '../view/GasManage/GasConfigSettle/GasConfigSettle'
import GasMonitoring from '../view/GasManage/GasMonitoring/GasMonitoring'

export default [
  /* 燃气控 */
  {
    path: '/gas_controller_management',
    name: 'gas-controller-management',
    components: {
      default: GasManagementNav,
      a: GasControllerManagement,
    },
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/gas_controller_add',
    name: 'gas-controller-add',
    components: {
      default: GasManagementNav,
      a: GasControllerAdd,
    },
  },
  {
    path: '/gas_controller_modify/:id',
    name: 'gas-controller-modify',
    components: {
      default: GasManagementNav,
      a: GasControllerModify,
    },
  },
  {
    path: '/gas_controller_device_status_log',
    name: 'gas-controller-device-status-log',
    components: {
      default: GasManagementNav,
      a: GasControllerDeviceStatusLog,
    },
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/gas_controller_current/:id',
    name: 'gas-controller-current',
    components: {
      default: GasManagementNav,
      a: GasControllerCurrent,
    },
  },
  {
    path: '/gas_ammeter_management',
    name: 'gas-ammeter-management',
    components: {
      default: GasManagementNav,
      a: GasAmmeterManagement,
    },
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/gas_ammeter_add',
    name: 'gas-ammeter-add',
    components: {
      default: GasManagementNav,
      a: GasAmmeterAdd,
    },
  },
  {
    path: '/gas_ammeter_current/:id',
    name: 'gas-ammeter-current',
    components: {
      default: GasManagementNav,
      a: GasAmmeterCurrent,
    },
  },
  {
    path: '/gas_ammeter_modify/:id',
    name: 'gas-ammeter-modify',
    components: {
      default: GasManagementNav,
      a: GasAmmeterModify,
    },
  },
  {
    path: '/gas_device_scene_config',
    name: 'gas-device-scene-config',
    components: {
      default: GasManagementNav,
      a: GasDeviceSceneConfig,
    },
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/gas_config_center',
    name: 'gas-config-center',
    components: {
      default: GasManagementNav,
      a: GasConfigCenter,
    },
  },
  {
    path: '/gas_config_modify',
    name: 'gas-config-modify',
    components: {
      default: GasManagementNav,
      a: GasConfigModify,
    },
  },
  {
    path: '/electronic_account_center',
    name: 'gas-account-center',
    components: {
      default: GasManagementNav,
      a: GasAccountCenter,
    },
  },
  {
    path: '/gas_config_settle',
    name: 'gas-config-settle',
    components: {
      default: GasManagementNav,
      a: GasConfigSettle,
    },
  },
  {
    path: '/gas_account_modify',
    name: 'gas-account-modify',
    components: {
      default: GasManagementNav,
      a: GasAccountModify,
    },
  },
  {
    path: '/gas_pay_record',
    name: 'gas-pay-record',
    components: {
      default: GasManagementNav,
      a: GasPayRecord,
    },
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/gas_settlement_record',
    name: 'gas-settlement-record',
    components: {
      default: GasManagementNav,
      a: GassettlementRecord,
    },
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/gas_rent_money',
    name: 'gas-rent-money',
    components: {
      default: GasManagementNav,
      a: GasRentMoney,
    },
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/gas_quantity',
    name: 'gas-quantity',
    components: {
      default: GasManagementNav,
      a: GasQuantity,
    },
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/gas_quantity_public',
    name: 'gas-quantity-public',
    components: {
      default: GasManagementNav,
      a: GasQuantityPublic,
    },
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/gas_monitoring',
    name: 'gas-monitoring',
    components: {
      default: GasManagementNav,
      a: GasMonitoring,
    },
    meta: {
      keepAlive: true,
    },
  },

  {
    path: '/gas/over_view',
    name: 'gas-over-view',
    components: {
      default: GasManagementNav,
      a: GasOverView,
    },
  },
  /* 燃气控 */

  // 智慧燃气操作日志
  {
    path: '/gas_log',
    name: 'gas-log',
    components: {
      default: GasManagementNav,
      a: Log,
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/GasManage.js